module.exports = __webpack_public_path__ + "img/ad001.dbcd261f.png";